import React from 'react';

const GroupAvatar = ({ groupName, size = 50, className = '' }) => {
  if (!groupName || typeof groupName !== 'string') {
    groupName = 'Group';
  }
  
  // Get the first letter and make it uppercase
  const firstLetter = groupName.trim().charAt(0).toUpperCase() || 'G';
  
  // Generate a color based on the group name for consistency
  const colors = [
    '#007bff', // blue
    '#28a745', // green
    '#dc3545', // red
    '#ffc107', // yellow
    '#6f42c1', // purple
    '#fd7e14', // orange
    '#20c997', // teal
    '#e83e8c', // pink
    '#6c757d', // gray
    '#343a40'  // dark
  ];
  
  // Simple hash function to get consistent color for same group name
  let hash = 0;
  for (let i = 0; i < groupName.length; i++) {
    hash = groupName.charCodeAt(i) + ((hash << 5) - hash);
  }
  const colorIndex = Math.abs(hash) % colors.length;
  const backgroundColor = colors[colorIndex];
  
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor: backgroundColor,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: `${Math.max(Math.floor(size * 0.4), 12)}px`,
    fontWeight: '600',
    fontFamily: 'inherit',
    userSelect: 'none',
    flexShrink: 0,
    textAlign: 'center',
    lineHeight: 1,
    // Ensure it doesn't break flex layout
    alignSelf: 'flex-start'
  };
  
  return (
    <div className={`group-avatar ${className}`} style={style}>
      {firstLetter}
    </div>
  );
};

export default GroupAvatar;
